/* models/widgets/abstract_icon */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var model_1 = require(62) /* ../../model */;
    var dom_view_1 = require(6) /* ../../core/dom_view */;
    var AbstractIconView = /** @class */ (function (_super) {
        tslib_1.__extends(AbstractIconView, _super);
        function AbstractIconView() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        AbstractIconView.__name__ = "AbstractIconView";
        return AbstractIconView;
    }(dom_view_1.DOMView));
    exports.AbstractIconView = AbstractIconView;
    var AbstractIcon = /** @class */ (function (_super) {
        tslib_1.__extends(AbstractIcon, _super);
        function AbstractIcon(attrs) {
            return _super.call(this, attrs) || this;
        }
        AbstractIcon.__name__ = "AbstractIcon";
        return AbstractIcon;
    }(model_1.Model));
    exports.AbstractIcon = AbstractIcon;
}
